import React from 'react';
import { TldOfferWidgetModule } from '../../../module/TldOfferWidget';
export const BmTldStrip = _ref => {
  let domain = _ref.domain,
    variant = _ref.variant;
  const _TldOfferWidgetModule = TldOfferWidgetModule.SDK.bm,
    BmTldStripExpand = _TldOfferWidgetModule.expand,
    BmTldStripCarousel = _TldOfferWidgetModule.carousel;
  return variant === 'B' ? /*#__PURE__*/React.createElement(BmTldStripExpand, {
    domain: domain
  }) : /*#__PURE__*/React.createElement(BmTldStripCarousel, {
    domain: domain
  });
};
//# sourceMappingURL=BmTldStrip.js.map